<script setup lang="ts">
import { timeAgo } from "@/modules/common";
import { useHouseMapStore } from "../../store/houseMap";
import { showConfirmDialog, showLoadingToast } from "vant";
import { useGlobalUser } from "@/stores/globalUser";
import { onBeforeMount } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const houseMapStore = useHouseMapStore();
const userStore = useGlobalUser();

onBeforeMount(() => {
  houseMapStore.houseMapIds = [];
  houseMapStore.pageNo = 1;
});

const onDeleteClick = async (id: number) => {
  try {
    await showConfirmDialog({
      title: "确定要删除吗？",
      message: "删除后将无法恢复",
      confirmButtonText: "确定",
      cancelButtonText: "取消",
    });
    await houseMapStore.deleteHouseMap(id);
  } catch {
    // ignore cancel
    return;
  }
};

const onSetDefaultClick = async (id: number | null) => {
  const loading = showLoadingToast("");
  try {
    await userStore.updateUserApi({
      defaultHouseMapId: id,
    });
  } finally {
    loading.close();
  }
};

const FURNISH_PATH = import.meta.env.VITE_FURNISH_PATH;
</script>
<template>
  <div class="w-full h-full grid-rows-[auto_1fr] overflow-hidden">
    <ThreadsNav
      show-back
      :go-back="
        () =>
          router.replace({
            name: 'dreamHome',
          })
      "
    >
      <template #center>
        <div>装修方案</div>
      </template>
      <template #right>
        <a
          class="btn btn-sm btn-primary rounded hover:text-primary-content"
          :href="FURNISH_PATH"
        >
          创建
        </a>
      </template>
    </ThreadsNav>
    <div class="w-full h-full overflow-hidden">
      <ThreadList
        :enable-pull-load="false"
        :on-scroll-load="houseMapStore.fetchNextPage"
      >
        <div class="grid grid-cols-2">
          <div
            class="m-1 p-2 flex flex-col gap-2 bg-base-300 rounded cursor-pointer"
          >
            <div class="w-full aspect-[2/1] rounded overflow-hidden">
              <VanImage
                src="/img/dream-room-preview.png"
                class="w-full h-full rounded"
                fit="cover"
              />
            </div>
            <div class="flex flex-col gap-1 flex-1">
              <div class="font-bold w-full line-clamp-1">默认</div>
              <div class="text-sm text-base-content/50 w-full line-clamp-1">
                一个温馨的单人公寓，适合一个人居住，生活必须品一应俱全，除了没什么个性外几乎没有太大问题。
              </div>
              <div class="flex justify-between items-center flex-1">
                <div class="flex items-center">
                  <button
                    v-if="userStore.user.defaultHouseMapId !== null"
                    class="btn btn-xs btn-ghost rounded"
                    @click="onSetDefaultClick(null)"
                  >
                    使用
                  </button>
                  <i
                    v-else
                    class="iconify mingcute--check-circle-line text-xs text-success"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            v-for="houseMap in houseMapStore.houseMapList"
            :key="houseMap.id"
            class="m-1 p-2 flex flex-col gap-2 bg-base-300 rounded cursor-pointer"
          >
            <div class="w-full aspect-[2/1] rounded overflow-hidden bg-black">
              <VanImage
                class="w-full h-full rounded"
                :src="houseMap.screenshotzz?.[0]?.url"
                fit="contain"
              />
            </div>
            <div class="flex flex-col gap-1">
              <div class="font-bold w-full line-clamp-1">
                {{ houseMap.name }}
              </div>
              <div class="text-sm text-base-content/50 w-full line-clamp-1">
                {{ houseMap.description || "暂无描述" }}
              </div>
              <div class="flex flex-col gap-1 justify-end flex-1">
                <div class="flex items-center gap-0.5">
                  <button
                    v-if="houseMap.id !== userStore.user.defaultHouseMapId"
                    class="btn btn-xs rounded"
                    @click="onSetDefaultClick(houseMap.id)"
                  >
                    使用
                  </button>
                  <i
                    v-else
                    class="iconify mingcute--check-circle-line text-xs text-success"
                  />
                  <a
                    class="btn btn-xs rounded hover:text-base-content"
                    :href="`${FURNISH_PATH}?uuid=${houseMap.uuid}`"
                  >
                    修改
                  </a>
                  <button
                    v-if="houseMap.id !== userStore.user.defaultHouseMapId"
                    class="btn btn-xs rounded"
                    @click="onDeleteClick(houseMap.id)"
                  >
                    删除
                  </button>
                </div>
                <div class="text-xs text-base-content/50">
                  {{ timeAgo(houseMap.dtUpdate) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </ThreadList>
    </div>
  </div>
</template>
